import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterModule } from '@angular/router';
import { ListLoginComponent } from '../../../public/login/list-login/list-login.component';
import { InscriptionEtapeComponent } from '../../../public/accueil/inscription-etape.component';
import { DevenirComponent } from '../../utilisateur/devenir/devenir.component';
import { ApiService } from '../../../service/api/api.service';
import { CheckComponent } from '../../../public/user/check/check.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  imports: [CommonModule],
  styleUrl : './footer.component.scss'
})
export class FooterComponent {

  currentYear: number = new Date().getFullYear();

  //  Injection correcte
  constructor(private modalService: NgbModal,private api: ApiService, private router: Router) {}

openModal_connexion() {
    let options: any = {
      centered: true,
      scrollable: true,
      size: "lg"//'sm' | 'lg' | 'xl' | string
    }
    const modalRef = this.modalService.open(ListLoginComponent, { ...options, backdrop: 'static', })
    modalRef.result.then(async (result: any) => {
      // console.log('Modal closed with:', result);
      if (result?.status) {
        await this.api.save_on_local_storage("token", result?.data)
        await this.api.save_on_local_storage("les_actions", result?.les_actions)
        await this.api.update_data_from_token()
        this.api.Swal_success("Opération éffectuée avec succés")
        this.router.navigate(['/home'])
      } else {
        // Gérer le cas d'échec de la connexion
      }
    })
  }

  openModal_inscription() {
    let options: any = {
      centered: true,
      scrollable: true,
      size: "lg"//'sm' | 'lg' | 'xl' | string
    }
    const modalRef = this.modalService.open(InscriptionEtapeComponent, { ...options, backdrop: 'static', })
    modalRef.result.then(async (result: any) => {
      // console.log('Modal closed with:', result);
      if (result?.status) {
        await this.api.save_on_local_storage("token", result?.data)
        await this.api.save_on_local_storage("les_actions", result?.les_actions)  // Ajout : Enregistrer les_actions comme pour login
        await this.api.update_data_from_token()
        // console.log(this.api.token.user_connected)
        this.api.Swal_success("Opération éffectuée avec succés")
        this.router.navigate(['/home'])
      } else {
        // Gérer le cas d'échec de la connexion
      }
    })
  }
  devenir(event?: Event) {
    event?.preventDefault();

    // Si déjà connecté → ouvrir directement le modal Devenir partenaire
    if (this.api.token?.user_connected) {
      this.modalService.open(DevenirComponent, {
        centered: true,
        scrollable: true,
        size: 'lg',
        backdrop: 'static'
      });
      return;
    }

    // Sinon → ouvrir d'abord le modal Check (connexion / inscription)
    const modalRef = this.modalService.open(CheckComponent, {
      centered: true,
      scrollable: true,
      size: 'lg',
      backdrop: 'static'
    });
modalRef.componentInstance.desiredPrivilege = 3;
    modalRef.result.then(async (result: any) => {
      if (result?.status) {
        // Sauvegarder le token et mettre à jour les données utilisateur
        await this.api.save_on_local_storage("token", result.data);
        await this.api.update_data_from_token();

        this.api.Swal_success("Connexion réussie");

        // Une fois connecté → ouvrir le modal Devenir partenaire
        this.modalService.open(DevenirComponent, {
          centered: true,
          scrollable: true,
          size: 'md',
          backdrop: 'static'
        });
      }
    }).catch(() => {
      // Modal fermé sans succès (annulation) → rien à faire
    });
  }
}

